<template>
 <div>
      <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    >
    <el-table :data="list" border style="width: 100%" stripe>
    <el-table-column prop="deliveryNo" label="发货单号"> </el-table-column>
    <el-table-column prop="orderNo" label="订单号"> </el-table-column>
    <el-table-column prop="installNo" label="经销商单号"> </el-table-column>
    <el-table-column prop="invoiceRequest" label="开票要求"> </el-table-column>
    <el-table-column prop="customerName" label="客户名称"> </el-table-column>
    <el-table-column prop="productCode" label="产品编码"> </el-table-column>
    <el-table-column prop="desc" label="中文描述"> </el-table-column>
    <el-table-column prop="gg" label="规格"> </el-table-column>
    <el-table-column prop="taxRate" label="税率"> </el-table-column>
    <el-table-column prop="num" label="数量"> </el-table-column>
    <el-table-column prop="unit" label="单位"> </el-table-column>
    <el-table-column prop="invoiceName" label="开票名称"> </el-table-column>
    <el-table-column prop="invoiceNo" label="发票号"> </el-table-column>
    <el-table-column prop="invoiceGg" label="开票规格"> </el-table-column>
    <el-table-column prop="invoiceNum" label="开票数量"> </el-table-column>
    <el-table-column prop="invoiceUnit" label="开票单位"> </el-table-column>
    <el-table-column prop="unitPrice" label="本位币含税单价"> </el-table-column>
    <el-table-column prop="unitNoTaxPrice" label="本位币不含税金额/元"> </el-table-column>
    <el-table-column prop="accountTaxAmount" label="本位币税额/元"> </el-table-column>
    <el-table-column prop="sumAmount" label="本位币含税金额/元"> </el-table-column>
    <el-table-column prop="splitNum" label="拆分数量"> </el-table-column>
    <el-table-column prop="sellArea" label="销售区域"> </el-table-column>
    <el-table-column prop="trxDate" label="记账日期"> </el-table-column>
    <el-table-column prop="productType" label="产品类型"> </el-table-column>
    <el-table-column prop="currencyCode" label="币种"> </el-table-column>
    <el-table-column prop="weight" label="重量/吨"> </el-table-column>
    <el-table-column prop="netWeight" label="结算重量/吨"> </el-table-column>
    <el-table-column prop="length" label="长度(m)"> </el-table-column>
    <el-table-column prop="boxNum" label="箱数"> </el-table-column>
    <el-table-column prop="hsPrice" label="含税单价"> </el-table-column>
    <el-table-column prop="hsAmount" label="含税金额/元"> </el-table-column>
    <el-table-column prop="taxpayerId" label="纳税人识别号"> </el-table-column>
    <el-table-column prop="addressTelephone" label="电话及地址"> </el-table-column>
    <el-table-column prop="bankAccount" label="开户行及账户"> </el-table-column>
    <el-table-column prop="invoiceRemark" label="开票备注"> </el-table-column>
    <el-table-column prop="coalitionDeliveryNo" label="合并开票的发货单"> </el-table-column>
    <el-table-column prop="invoiceTime" label="开票时间"> </el-table-column>
    
  </el-table>
 </div>
</template>

<script>
export default {
  created() {
    let invoiceSeq = this.$route.params.id;

    this.$axios
      .postReq("/meide/REST/ajaxOrderReport", {
        postType: "queryInvoiceDetail",
        invoiceSeq
      })
      .then((res) => {
        this.list = res.data;
      });
  },
      methods:{
          daochu() {
    let invoiceSeq = this.$route.params.id;
      this.$axios
        .postReq("/meide/REST/ajaxOrderExport", {
          postType: "exportInvoiceDetail",
          invoiceSeq,
        })
        .then((res) => {
          if (res.success == "true") {
            let url = res.url;
            window.open(url);
          } else {
            // this.$message.error(res.ErrorText);
          }
        });
    },
    },
  data() {
    return {
      list: [],
    };
  },
};
</script>